import outline from './outline'
import opened from './opened'
import current from './current'

const state = {
  sidebarVisible: true,
  presentationMode: false,
  sidebarItems: {
    catalog: {
      folded: false
    },
    outline: {
      folded: false
    },
    noteDetails: {
      folded: false
    },
    notebookDetails: {
      folded: false
    },
    opened: {
      folded: false
    }
  }
}

const getters = {
  sidebarVisible (state) {
    return state.sidebarVisible
  },
  presentationMode (state) {
    return state.presentationMode
  },
  isFolded (state) {
    return (item) => {
      return state.sidebarItems[item].folded
    }
  }
}

const mutations = {
  SET_SIDEBAR_VISIBLE (state, visible) {
    state.sidebarVisible = visible
  },
  SET_PRESENTATION_MODE (state, presentationMode) {
    state.presentationMode = presentationMode
  },
  TOGGLE_FOLDED (state, item) {
    state.sidebarItems[item].folded = !state.sidebarItems[item].folded
  }
}

const actions = {}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
  modules: {
    outline,
    opened,
    current
  }
}
